import React, { useState } from 'react';
import { Grid, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import FilterComponent from './filtros';
import Legenda from './legenda';

const PainelCrack = ({ municipios, onChange, onSelectMunicipio, legendData, selectedUF, currentColor }) => {
    const [isExpanded, setIsExpanded] = useState(true);

    const togglePanel = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <Grid className="legenda" style={{ backgroundColor: 'rgba(83, 108, 149, 0.5)', padding: '1em', borderRadius: '8px', position: 'relative' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <p style={{ margin: '0.4em', textAlign: 'center' }}>Painel de controle</p>
                <IconButton onClick={togglePanel} style={{ color: 'white' }}>
                    <MenuIcon />
                </IconButton>
            </div>
            {isExpanded && (
               <>
            <FilterComponent municipios={municipios} onChange={onChange} onSelectMunicipio={onSelectMunicipio}
            />
                <Legenda legendData={legendData} selectedUF={selectedUF} currentColor={currentColor}
                 />
                 </>

            )}
        </Grid>
    );
};

export default PainelCrack;
